// extracted by mini-css-extract-plugin
export var iconRight = "GenericLink-module--iconRight--1034a";
export var link = "GenericLink-module--link--52f20";